/**
 * Formats error details into a copyable diagnostic string.
 * Excludes sensitive data (tokens, passwords, PII).
 */
export function formatErrorForClipboard({
  error,
  componentStack,
  appVersion,
  userRole,
}: {
  error?: unknown;
  componentStack?: string | null;
  appVersion?: string | null;
  userRole?: string | null;
}): string {
  const message =
    error instanceof Error ? error.message : String(error || 'Unknown error');

  const stack =
    error instanceof Error && error.stack ? error.stack : 'N/A';

  const cStack = componentStack || 'N/A';

  return [
    'ERROR REPORT',
    '----------------------------------------------------',
    'Timestamp:',
    new Date().toLocaleString(),
    '',
    'URL:',
    window.location.href,
    '',
    'Message:',
    message,
    '',
    'Stack:',
    stack,
    '',
    'Component Stack:',
    cStack,
    '',
    'Browser:',
    navigator.userAgent,
    '',
    'App Version:',
    appVersion || 'Unavailable',
    '',
    'User Role:',
    userRole || 'Unavailable',
  ].join('\n');
}

/**
 * Fallback copy method for environments where navigator.clipboard is unavailable.
 */
export function fallbackCopyTextToClipboard(text: string): void {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-9999px';
  textArea.style.top = '0';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    document.execCommand('copy');
  } finally {
    document.body.removeChild(textArea);
  }
}
